import MetaContainer from './MetaContainer';

export default MetaContainer;
